<div class="tags-filter">
  <div *ngFor="let option of options"
       class="tag"
       [ngClass]="'tag-wv-tool-tag-blue'"
       [class.select]="option.selected"
       (click)="onToggleSelected(option)">
    {{option.label}}
  </div>
</div>
